export enum EAdminPermission {
    ADMIN_PERM = 'admin-perm'
}

export enum EUserPermission {
    USER_PERM = 'user-perm',
    VIEWER = 'viewer'
}
